import NextImage, { type ImageProps } from 'next/image';
import {
  isStaticAssetCdnSrc,
  rewriteStaticAssetSrc,
} from '@/lib/static-asset-url';

/**
 * Shared image. Legacy S3 hosts are rewritten to static.qualidoc.com.br here,
 * during render, so the HTML already points at the cache.
 *
 * Those URLs stay unoptimized: the browser fetches the CDN directly.
 * Routing them through `/_next/image` would put the shop server in front of the cache.
 */
export const Image = ({ src, unoptimized, ...rest }: ImageProps) => {
  const resolvedSrc = rewriteStaticAssetSrc(src);
  const directFromCdn = isStaticAssetCdnSrc(resolvedSrc);

  return (
    <NextImage
      {...rest}
      src={resolvedSrc}
      unoptimized={directFromCdn ? true : (unoptimized ?? true)}
    />
  );
};
